(() => {
  'use strict';
  const topics = Object.freeze({
    delivery: ['faq_delivery'],
    pickup: ['faq_contact'],
    fit: ['faq_fit', 'faq_buckle'],
    offers: ['faq_offer', 'faq_gift'],
    order: ['faq_order', 'faq_cancel']
  });
  function responses(topic, lookup) {
    return (topics[topic] || []).map(key => ({question: lookup(key + '_q'), answer: lookup(key + '_a')})).filter(row => row.question && row.answer);
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {topics, responses};
  if (typeof document === 'undefined') return;
  function init(widget) {
    if (widget.dataset.serviceReady) return;
    widget.dataset.serviceReady = 'true';
    const root = widget.closest('[data-color-builder]');
    const faq = root?.querySelector('.cb-faq');
    const output = widget.querySelector('[data-service-answer]');
    const buttons = [...widget.querySelectorAll('[data-service-topic]')];
    if (!root || !faq || !output) return;
    let selected = '';
    const lookup = key => faq.querySelector('[data-copy="' + key + '"]')?.textContent?.trim() || '';
    function render() {
      widget.querySelector('[role="group"]').setAttribute('aria-label', widget.querySelector('[data-service-help-title]').textContent);
      if (!selected) return;
      const rows = responses(selected, lookup);
      const fragment = document.createDocumentFragment();
      for (const row of rows) {
        const heading = document.createElement('h3');
        heading.textContent = row.question;
        const paragraph = document.createElement('p');
        paragraph.textContent = row.answer;
        fragment.append(heading, paragraph);
      }
      if (!rows.length) {
        const paragraph = document.createElement('p');
        paragraph.textContent = root.querySelector('[data-copy="faq_no_results"]')?.textContent || '';
        fragment.append(paragraph);
      }
      output.replaceChildren(fragment);
      for (const button of buttons) button.setAttribute('aria-pressed', String(button.dataset.serviceTopic === selected));
      widget.querySelector('[data-service-help-links]').hidden = selected !== 'order' && rows.length > 0;
    }
    for (const button of buttons) button.addEventListener('click', () => { selected = button.dataset.serviceTopic; render(); });
    new MutationObserver(render).observe(faq, {childList: true, characterData: true, subtree: true});
    render();
  }
  function mount(scope) { scope.querySelectorAll('[data-service-help]').forEach(init); }
  mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
